export const LOCAL_STORAGE_KEY = 'brands_app_session';

export const LOGIN_URL = `${process.env.REACT_APP_COGNITO_CLIENT_DOMAIN}/login?response_type=code&client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT_URI}`;